<template>
  <div class="error-container">
    <div class="content">
      <div class="logo">
        <img src="~@/assets/404_logo.png" alt="404">
      </div>
      <article>
        <h3>无法访问此网站</h3>
        <p>请试试一下方法：</p>
        <p>1.检查网络链接</p>
        <p>2.检查代理服务器和防火墙</p>
        <p><x-button  
          @click="handleRefresh"
          width="320px" 
          text="刷新重试"></x-button></p>
        
      </article>
    </div>
  </div>
</template>

<script>
import xButton from './button'
export default {
  components: {
    xButton 
  },
  methods: {
    handleRefresh() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
.error-container { 
  height: 100vh; 
  background: 
    url(../assets/error_l1.png) 0 bottom no-repeat,
    url(../assets/error_r1.png) right 0  no-repeat, 
    url(../assets/error_bg.png) 0 0 no-repeat; 
  color: #916733;
  display:flex;
  align-items: center;
  justify-content: center; 
  .x-button {
    margin: 32px auto;
  }
  h3 {
    font-size: 34px;
    font-weight:400;
  }
  p {
    font-size: 18px;
    margin:0.5em;
  }
}
</style>